import React, { cloneElement } from "react";
import classNames from "classnames";
import TagWrapper from "./../TagWrapper";
import Label from "./Label";
import FormText from "./FormText";

const FormGroup = ({
  children,
  tag = "div",
  className,
  labelClassName,
  childWrapperClassName,
  label,
  id,
  isFloating,
  size,
  isColForLabel,
  isHiddenLabel,
  formText,
  ...props
}) => {
    const isRequired = React.Children.toArray(children).some(
    (child) => child.props?.required
  );
  const LABEL = (
    <Label
      className={labelClassName}
      htmlFor={id}
      isHidden={isHiddenLabel}
      isColForLabel={isColForLabel}
      size={size}
    >
      {label}
      {isRequired && <span style={{ color: "red" }}> *</span>}
    </Label>
  );

  const CHILDREN =
    id && !Array.isArray(children)
      ? cloneElement(children, {
          id,
          size: size || children?.props.size,
          placeholder: isFloating ? label : children.props.placeholder,
          "aria-describedby": formText ? `${id}-text` : null,
        })
      : children;

  const FORM_TEXT = formText && (
    <FormText id={`${id}-text`}>{formText}</FormText>
  );

  return (
    <TagWrapper
      tag={tag}
      className={classNames(
        { "form-floating": isFloating, row: isColForLabel },
        className
      )}
      {...props}
    >
      {label && !isFloating && LABEL}

      {childWrapperClassName ? (
        <div className={childWrapperClassName}>
          {CHILDREN}
          {FORM_TEXT}
        </div>
      ) : (
        CHILDREN
      )}

      {label && isFloating && LABEL}

      {!childWrapperClassName && FORM_TEXT}
    </TagWrapper>
  );
};

export default FormGroup;
